import { InjectionToken } from '@angular/core';

export class ToastData {
    text: string;
    timeout?: number;
    showClose?: boolean;
    icon?: string[];
    showIcon?: boolean;
    iconBorder?: boolean;
    action?: {
        text: string;
        handler: () => void;
    };
}

export interface ToastConfig {
    position?: {
        bottom: number;
    };
    animation?: {
        fadeOut: number;
        fadeIn: number;
    };
}

export const defaultToastConfig: ToastConfig = {
    position: {
        bottom: 78
    },
    animation: {
        fadeOut: 300,
        fadeIn: 300
    }
};

export const TOAST_CONFIG_TOKEN = new InjectionToken('fcp-toast-config');
